import HttpClientManager from '@/business/core/clients/http/helpers/manager.helper';
import type { IRegisterUserRequest, IUpdateUserInformation, IGetUserInformation, IVerifyOtpResponse } from '@/business/modules/auth/auth.model';

class AuthRepository {
	httpClient: any;
	static #instance: AuthRepository;
	readonly ACCOUNT: string = 'Account';

	private constructor() {
		this.httpClient = HttpClientManager.getInstance();
	}

	public static getInstance(): AuthRepository {
		if (!AuthRepository.#instance) {
			AuthRepository.#instance = new AuthRepository();
		}

		return AuthRepository.#instance;
	}

	signup(data: IRegisterUserRequest) {
		return this.httpClient(`${this.ACCOUNT}/Register`, {
			method: 'post',
			data: { ...data },
		});
	}

	loginInit(phoneNumber: string) {
		return this.httpClient(`${this.ACCOUNT}/LoginInit`, {
			method: 'get',
			params: { PhoneNumber: phoneNumber },
		});
	}

	verifyOtp(otpCode: string): Promise<IVerifyOtpResponse> {
		return this.httpClient(`${this.ACCOUNT}/Login`, {
			method: 'get',
			params: { code: otpCode },
		});
	}

	loginAsAdmin(otpCode: string) {
		return this.httpClient(`${this.ACCOUNT}/Admin/Login`, {
			method: 'get',
			params: { code: otpCode },
		});
	}

	updateUserInformation(userData: IUpdateUserInformation) {
		return this.httpClient(`${this.ACCOUNT}/UpdateUser`, {
			method: 'put',
			data: {
				...userData,
			},
			isShowNotify: true,
		});
	}

	loginByRefreshToken() {
		return this.httpClient(`${this.ACCOUNT}/LoginByRefreshToken`, {
			method: 'get',
			config: 'refresh',
		});
	}

	getUserInformation(): Promise<IGetUserInformation> {
		return this.httpClient(`${this.ACCOUNT}/GetInformation`, {
			method: 'get',
		});
	}
}

export default AuthRepository;
